<template>
  <b-modal
    id="extraPackageForm"
    class="vellos-form"
    :title="modalTitle"
    centered
    hide-footer
  >
    <b-overlay
      :show="loading"
      rounded="sm"
      variant="transparent"
      opacity="1"
      blur="1px"
    >
      <b-container v-if="profile">
        <b-row>
          <b-col class="mt-n4">
            <b-row v-if="showCard && showDefaultCard">
              <b-col>
                <add-card
                  type="Purchase"
                  @cancel="showCard = false"
                  @complete="
                    ;(showCard = false),
                      (showDefaultCard = false),
                      proceedPurchase()
                  "
                />
              </b-col>
            </b-row>

            <b-row v-else>
              <b-col>
                <b-form-group>
                  <p class="pt-3">
                    Enjoy a 5 hour fishing trip exploring Paul’s local waters of
                    Port Phillip Bay, Western Port and Bass Strait targeting
                    species such as snapper, squid, whiting, gummy sharks, tuna
                    and more!
                  </p>

                  <p>
                    Paul will be your host for the session, sharing all of his
                    tricks of the trade. This was a money can’t buy experience,
                    then along came Vello.
                  </p>

                  <p>
                    Dates and species are seasonal. Subject to Paul’s
                    availability. The price is for a party of up to 4 people.
                  </p>

                  <p>
                    After the purchase is made Paul will contact you directly to
                    arrange the date!
                  </p>

                  <b-button
                    variant="info"
                    size="sm"
                    class="radius-15 py-3 px-4 mt-4 light w-100"
                    @click="proceedPurchase"
                  >
                    {{ buttonLabel }}
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AddCard from './AddCard'

export default {
  name: 'VipAccessModal',
  components: { AddCard },

  data() {
    return {
      selected_type: 'vip',
      loading: false,
      showCard: false,
      showDefaultCard: true,
    }
  },

  computed: {
    ...mapState({
      card: (state) => state.auth.card,
      profile: (state) => state.influencer.profile,
      extra_package: (state) => state.influencer.extra_package,
    }),

    modalTitle: function () {
      return `VIP FISHING TRIP WITH PAUL`
    },

    buttonLabel() {
      if (this.extra_package) {
        return `Purchase (${this.extra_package.symbol} ${this.extra_package.price})`
      }

      return `Purchase`
    },
  },

  methods: {
    ...mapActions({
      getProfile: 'influencer/getProfile',
      getExtraPricing: 'influencer/getExtraPricing',
    }),

    async proceedPurchase() {
      if (!this.card || this.showDefaultCard) {
        this.showCard = true
        return
      }

      this.showDefaultCard = true
      this.showCard = false
      this.loading = true

      let params = {
        package_id: this.extra_package.package_id,
        influencer_uid: this.profile.influencer.influencer_uid,
      }

      await this.$api
        .post(`influencer/${params.influencer_uid}/subscribe`, params)
        .then(({ data }) => {
          this.loading = false
          this.showToast('success', data.message)
        })
        .catch((error) => {
          this.loading = false
          this.showToast('danger', error.response.data.message)
        })

      this.$root.$emit('bv::hide::modal', 'extraPackageForm')
    },

    showToast(type, message) {
      this.$bvToast.toast(message, {
        variant: type,
        noCloseButton: true,
        toaster: 'b-toaster-bottom-right',
      })
    },
  },

  async created() {
    if (this.profile) {
      await this.getExtraPricing(this.profile.influencer.influencer_uid)
    }
  },
}
</script>

<style lang="scss" scoped></style>
